export class TagTransformer {
  static transform(obj) {
    let tag = {};

    tag.id = obj.id;
    tag.type = obj.attributes.type;
    tag.name = obj.attributes.name;
    tag.displayName = obj.attributes.display_name;
    tag.pivot = obj.attributes.pivot;

    return tag;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/tags/tag.transformer.js